<template>
	<div
		v-if="isOpenDialog"
		:class="[
			'base-dialog',
			{ 'is-large': options.size === 'large' },
			{ 'is-medium': options.size === 'medium' },
			{ 'is-small': options.size === 'small' },
		]"
	>
		<div @click="closeDialog" class="base-dialog__overlay"></div>
		<div class="base-dialog__container">
			<div class="base-dialog-header">
				<h1 class="base-dialog-header__title">{{ options.title || '알림' }}</h1>
			</div>

			<div class="base-dialog-body">
				<div class="base-dialog-body__contents">
					<slot name="message"></slot>
				</div>
			</div>

			<div class="base-dialog-footer">
				<a
					v-if="options.isCancelLabel !== false"
					@click.prevent="closeDialog"
					class="base-dialog-footer__btn base-dialog-footer__btn--cancel"
				>
					{{ options.cancelLabel || '닫기' }}
				</a>
				<a class="base-dialog-footer__btn" @click.prevent="clickOkLabel">
					{{ options.okLabel || '확인' }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		options: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		isOpenDialog() {
			return this.$store.getters['dialogStore/isOpenDialog'];
		},
	},
	methods: {
		closeDialog() {
			this.$store.dispatch('dialogStore/closeDialog');
		},
		clickOkLabel() {
			this.closeDialog();
			this.$emit('okCallback');
		},
	},
};
</script>

<style scoped>
.base-dialog {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 8px;
}

.base-dialog__overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(49, 49, 49, 0.15);
}

.base-dialog__container {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 640px;
	max-height: 75vh;
	padding: 1.25rem 0 0;
	border-radius: 3px;
	background: #fff;
	box-shadow: 0 4px 10px rgb(69 77 93 / 30%);
}

.base-dialog.is-large .base-dialog__container {
	max-width: 960px;
}

.base-dialog.is-medium .base-dialog__container {
	max-width: 640px;
}

.base-dialog.is-small .base-dialog__container {
	max-width: 320px;
}

.base-dialog-header {
	padding: 0 1rem;
}

.base-dialog-header__title {
	color: #222;
	font-size: 1.25rem;
	font-weight: 500;
	text-align: center;
}

.base-dialog-body {
	padding: 0 1rem 1.25rem;
	overflow-y: auto;
}

.base-dialog-body__contents {
	padding: 0.625rem 0;
	font-size: 0.875rem;
	font-weight: 300;
	line-height: 1.5;
	text-align: center;
	white-space: pre-line;
}

.base-dialog-footer {
	display: flex;
	justify-content: space-around;
	padding: 0;
	border-top: 1px solid #c8c8c8;
}

.base-dialog-footer__btn {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 3em;
	border-left: 1px solid #c8c8c8;
	color: #222;
	font-size: 1rem;
	line-height: 1;
}

.base-dialog-footer__btn--cancel {
	color: #666;
}

.base-dialog-footer__btn:first-child {
	border-left: 0;
}
</style>
